import { computed, Ref } from 'vue';

export function useFormHelper(rules: Ref<string | object>) {
  const isOptional = computed(() => {
    if (typeof rules.value === 'string') {
      return !rules.value.includes('required');
    } else {
      return !Object.keys(rules.value).includes('required');
    }
  });

  return {
    isOptional,
  };
}
